import { IWeightAndColor } from 'fitbeat.gym-core';
import React from 'react';
import { StyleSheet, Text, TextStyle, TouchableOpacity, View, ViewStyle } from 'react-native';
import theme from '../theme';
import { RadioButton } from '../ui/components';
import { defaultScale, scaleText } from '../utils/scaling';

interface IProps {
  weightAndColor: IWeightAndColor;
  weightOptionContainerStyle?: ViewStyle;
  isSelected: boolean;
  weigthTextStyle?: TextStyle;
  toggleSelection(): void;
}
export const RadioButtonAndEquipmentSelection: React.FunctionComponent<IProps> = ({
  weightAndColor,
  isSelected,
  toggleSelection,
  weigthTextStyle,
  weightOptionContainerStyle,
}) => {
  const { color, weight } = weightAndColor;
  return (
    <TouchableOpacity
      style={styles.radioButtonAndWeightContainer}
      onPress={toggleSelection}
    >
      <RadioButton
        outerContainer={styles.radioButtonOuterContainer}
        innerActiveStyle={styles.radioButtonInnerActiveStyle}
        outerActiveContainer={styles.radioButtonOuterActiveContainer}
        innerInactiveStyle={styles.radioButtonInnerInactiveStyle}
        isSelected={isSelected}
        toggleSelection={toggleSelection}
      />
      <View style={[styles.weightContainer, { backgroundColor: color }, weightOptionContainerStyle]}>
        <Text style={[styles.weightText,weigthTextStyle]}>{weight}</Text>
      </View>
    </TouchableOpacity>
  );
};

const styles = StyleSheet.create({
  radioButtonAndWeightContainer: {
    alignItems: 'center',
    flexDirection: 'row',
    marginBottom: defaultScale(9),
    paddingVertical: defaultScale(10),
    paddingHorizontal: defaultScale(15),
    borderWidth: defaultScale(1),
    borderColor: '#ECECEC',
    alignSelf: 'center',
  },
  weightContainer: {
    marginLeft: defaultScale(18),
    width: defaultScale(250),
    height: defaultScale(45),
    justifyContent: 'center',
    alignItems: 'center',
  },
  radioButtonOuterContainer: {
    height: defaultScale(30),
    width: defaultScale(30),
    borderRadius: defaultScale(15),
    backgroundColor: '#D9D9D9',
  },
  radioButtonInnerActiveStyle: {
    backgroundColor: theme.WHITE,
  },
  radioButtonOuterActiveContainer: {
    backgroundColor: theme.BLACK,
  },
  radioButtonInnerInactiveStyle: {
    backgroundColor: '#D9D9D9',
  },
  weightText: {
    ...theme.textStyle.display1Bold,
    textTransform: 'uppercase',
    color: theme.WHITE,
    fontWeight: '800',
    fontSize: scaleText(25),
  },
});
